import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router';
import Tabs from './Tabs';
import { getTabs } from '@/utils/projectUtils';
import { useResources } from '@/stores/resourcesStore';

const ProjectSidebarLinks = ({ isCollapsed }) => {
  const data = useResources();
  const location = useLocation();
  const params = useParams();
  const tabs = getTabs(location, data, params);

  return <Tabs tabs={tabs} isCollapsed={isCollapsed} />;
};

ProjectSidebarLinks.propTypes = {
  isCollapsed: PropTypes.bool,
};

export default ProjectSidebarLinks;
